import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import get from 'lodash/get';
import { getFeatureFlags } from 'platform-components/src/components/app-factory/selectors';
import { createSelector } from 'reselect';

import { getStudentsCount } from 'common.components/classes/selectors';
import { getCoursesTemplatesList, getCoursesTemplatesLoadingStatus } from 'store/courses-templates/selectors';

import { ReduxTeacherStore } from '../../typings';

const classStateSelector = (storeState: ReduxTeacherStore) => get(storeState, 'class');

export const getIsClassNameEditorModalOpened = createSelector(classStateSelector, (state) =>
    get(state, 'isClassNameEditorModalOpened')
);

export const getIsArchivateClassModalOpened = createSelector(classStateSelector, (state) =>
    get(state, 'isArchivateClassModalOpened')
);

export const getIsModalOpened = createSelector(classStateSelector, (state) => get(state, 'isModalOpened'));

export const getClassDeleteValidationMessageId = createSelector([getStudentsCount], (studentsCount) => {
    if (studentsCount > 0) {
        return 'class.deleteErrorMessage.hasStudents';
    }

    return null;
});

export const getShouldRedirect = createSelector(classStateSelector, (state) => get(state, 'shouldRedirect'));

export const getCreatedTeamId = createSelector(classStateSelector, (state) => get(state, 'createdTeamId'));

export const getClassIdToDelete = createSelector(classStateSelector, (state) => get(state, 'classIdToDelete'));

export const getClassItemToArchive = createSelector(classStateSelector, (state) => get(state, 'classItemToArchive'));

export const getNewStudentsListLoadingStatus = createSelector(classStateSelector, (state) =>
    get(state, 'newStudentsListLoadingStatus')
);

export const getIsStudentsListModalOpened = createSelector(classStateSelector, (state) =>
    get(state, 'isStudentsListModalOpened')
);

export const getTemplatesLoadingStatus = createSelector(classStateSelector, (state) =>
    get(state, 'loadingTemplatesStatus')
);

export const getTemplates = createSelector(classStateSelector, (state) => get(state, 'templates'));

export const shouldShowSubjectsEmptyState = createSelector(
    [getCoursesTemplatesList, getCoursesTemplatesLoadingStatus],
    (templates, loadingStatus) => {
        const isLoaded = loadingStatus === LOADING_STATUSES.SUCCESS;
        return isLoaded && (templates.length === 0 || templates.every((template) => !template.is_assigned));
    }
);

export const getStudentCode = createSelector(classStateSelector, (state) => get(state, 'team_entering_code'));

export const getIsSubjectTeachersFeatureEnabled = createSelector([getFeatureFlags], (featureFlags): boolean =>
    Boolean(featureFlags?.subjectTeachersEnabled)
);
